import { Typography } from 'antd';
import React, { memo } from 'react';
import { useMediaQuery } from 'react-responsive';

import IconLabel from '@fmbt/ui/IconLabel';
import type { IconType } from '@fmbt/ui/icons';
import DefaultCard from 'components/atoms/DefaultCard';
import { blue } from 'style/colour-palette';
import { MAX_WIDTH_MOBILE } from 'style/constants';

import './styles.less';

interface OperationCardProps {
  title: string;
  caption: string;
  Icon: IconType;
  onClick: () => void;
}

function OperationCard({ title, caption, Icon, onClick }: OperationCardProps): JSX.Element {
  const isMobile = useMediaQuery({ maxWidth: MAX_WIDTH_MOBILE });
  return (
    <DefaultCard
      className="OperationCard"
      onClick={onClick}
    >
      <IconLabel
        icon={<Icon size={isMobile ? 40 : 28} color={blue} />}
        gap={16}
        label={<div>
          <Typography.Title level={5} className="mb-4">{title}</Typography.Title>
          <Typography.Text type="secondary">{caption}</Typography.Text>
        </div>}
      />
    </DefaultCard>
  );
}

export default memo(OperationCard);
